import Vue from "vue";
import VueI18n from "vue-i18n";

// element for i18n ui
import locale from "element-ui/lib/locale";
import eleEng from "element-ui/lib/locale/lang/en";
import eleTw from "element-ui/lib/locale/lang/zh-TW";

import store from "./store/index.js";

Vue.use(VueI18n)


function loadLocaleMessages(storeLanguage) {
  // check the number of languages in locales folder 
  const locales = require.context(
    "./locales",
    true,
    /.json$/
  );
  const messages = {};
  locales.keys().forEach(file => {
    const keyArr = file.split('/');
    keyArr.shift();
    messages[keyArr.join('.').replace(/\.json$/g, '')] = locales(file);
  });

  if (storeLanguage == 'tw') {
    return {
      tw: { ...messages.tw, ...eleTw },
      en: { ...messages.en, ...eleEng },
    };
  }
  else if (storeLanguage == 'en') {
    return {
      en: { ...messages.en, ...eleEng },
      tw: { ...messages.tw, ...eleTw },
    };
  }
}

const i18n = new VueI18n({
  locale: store.getters.getAppLanguage,
  messages: loadLocaleMessages(store.getters.getAppLanguage)
});

console.log("locale now:" + i18n.locale)
store.commit('setAppLanguage', i18n.locale)

locale.i18n((key, value) => i18n.t(key, value))

export default i18n